import React from "react";
import { getUserRole } from '../../utils/common';
import AdminDashboard from '../AdminDashboard'
import VehiclesMonitor from "./VehiclesMonitor";
import Vehicles from "./CLVehicleList";

function CheckDashboard() 
{
  
  const user_role = getUserRole();  
  const VMonitor=()=>{
    return (
     
      <main>
        <Vehicles/>
     {/*<VehiclesMonitor/>*/} 
      </main>
    
    );
  }
  
  let matter;
  if(user_role === "Admin")
  {

     matter= <main><AdminDashboard/></main>

  }
  else
  {

    matter=<VMonitor/>       

  }

  return (    <>
                {matter}
                </>
  );
}


export default CheckDashboard;